window.addEventListener('load', (event) => {

  var RecentlyViewedProductsSection = function() {
    var container = document.querySelector('[data-section-type="recently-viewed-products"]');
    if(container) {
      var options = JSON.parse(container.getAttribute('data-section-settings')); // Setup product item color swatch


      function _getSearchQueryString() {
        var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]'); // If we are on a product template, we make sure to remove the main product from the related product

        if (items.includes(options['productId'])) {
          items.splice(items.indexOf(options['productId']), 1);
        }

        return items.map(function (item) {
          return 'id:' + item;
        }).join(' OR ');
      }
      function _fetchProducts() {

        var queryString = _getSearchQueryString();

        if (queryString === '') {
          return;
        } 


        fetch("".concat(window.routes.searchUrl, "?section_id=").concat(container.getAttribute('data-section-id'), "&type=product&q=").concat(queryString), {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (response) {
          response.text().then(function (content) {
            var tempElement = document.createElement('div');

            tempElement.innerHTML = content; // Set the content
            container.innerHTML = tempElement.querySelector('.Section').innerHTML; // Show the section
            container.parentNode.style.display = 'block'; // And finally let's create the carousel !


            var productCardSwatches = container.querySelectorAll('.prod-card-color-options-item');          
            for (var i = 0; i < productCardSwatches.length; i++) {

              productCardSwatches[i].addEventListener('mouseenter', function(e) {
                var parentElement = e.target.closest('.product-card');
                var hoverImageParent = parentElement.querySelector('.product-card-hover-image');
                var mainImageParent = parentElement.querySelector('.product-card-main-image');
                var hoverImage = parentElement.querySelector('.product-card-hover-image > img');
                var imgAlt = e.target.getAttribute('data-img-alt');
                var imgWidth = e.target.getAttribute('data-img-width');
                var imgHeight = e.target.getAttribute('data-img-height');
                var imgSrc = e.target.getAttribute('data-img-src');
                var imgSrcset = e.target.getAttribute('data-img-srcset');

                if (hoverImage != null) {
                  hoverImage.setAttribute('alt',imgAlt);
                  hoverImage.setAttribute('width',imgWidth);
                  hoverImage.setAttribute('height',imgHeight);
                  hoverImage.setAttribute('src',imgSrc);
                  hoverImage.setAttribute('srcset',imgSrcset);
                }

                if (hoverImageParent != null) {
                  hoverImageParent.classList.add('show');
                }

                if (mainImageParent != null) {
                  mainImageParent.classList.add('hide');
                }
              });

              productCardSwatches[i].addEventListener('mouseleave', function(e) {  
                var parentElement = e.target.closest('.product-card');
                var hoverImageParent = parentElement.querySelector('.product-card-hover-image');
                var mainImageParent = parentElement.querySelector('.product-card-main-image');
                var hoverImage = parentElement.querySelector('.product-card-hover-image > img');
                if (hoverImageParent != null) {
                  hoverImageParent.classList.remove('show');
                }

                if (mainImageParent != null) {
                  mainImageParent.classList.remove('hide');
                }
              });

              productCardSwatches[i].addEventListener('click', function(e) {
                e.preventDefault();

                var parentElement = e.target.closest('.product-card');
                var hoverImageParent = parentElement.querySelector('.product-card-hover-image');
                var mainImageParent = parentElement.querySelector('.product-card-main-image');
                var mainImage = parentElement.querySelector('.product-card-main-image > img');
                var hoverImage = parentElement.querySelector('.product-card-hover-image > img');
                var productCardLink = parentElement.querySelector('.product-card-link');
                var imgAlt = e.target.getAttribute('data-img-alt');
                var imgWidth = e.target.getAttribute('data-img-width');
                var imgHeight = e.target.getAttribute('data-img-height');
                var imgSrc = e.target.getAttribute('data-img-src');
                var imgSrcset = e.target.getAttribute('data-img-srcset');
                var variantLink = e.target.getAttribute('href');

                if (mainImage != null) {
                  mainImage.setAttribute('alt',imgAlt);
                  mainImage.setAttribute('width',imgWidth);
                  mainImage.setAttribute('height',imgHeight);
                  mainImage.setAttribute('src',imgSrc);
                  mainImage.setAttribute('srcset',imgSrcset);
                }

                if (productCardLink != null) {
                  productCardLink.setAttribute('href',variantLink);
                }

                for (var j = 0; j < productCardSwatches.length; j++) {
                  productCardSwatches[j].classList.remove('is-active');
                }

                e.target.classList.add('is-active');
              });
            }

                
            //     var swiper= Swiper;
            //     var init = false;
             

            //     function swiperMode() {
            //     let mobile = window.matchMedia('(min-width: 0px) and (max-width: 991px)');
            //    var sliderWrapper = container.querySelector('#recently-viewed-products');
            
                
            //     if(mobile.matches) {
                
            //           if(init) {
            //             if(swiper) {
            //                   swiper.destroy();
            //             }
            //               init = false;
            //         }
            //     } else {
            //       if (!init) {
            // init = true;
            // swiper = new Swiper(sliderWrapper, {
            //   loop: false,
            //   slidesPerView: options['grid'],
            //   spaceBetween: 30,
            //   navigation: {
            //     nextEl: '.swiper-button-next-'+container.getAttribute('data-section-id'),
            //     prevEl: '.swiper-button-prev-'+container.getAttribute('data-section-id'),
            //   },
            //   breakpoints: {
            //     320: {
            //       slidesPerView: 1,
            //       spaceBetween: 0
            //     },
            //     641: {
            //       slidesPerView: 2,
            //       spaceBetween: 20
            //     },
            //     992: {
            //       slidesPerView: 3,
            //       spaceBetween: 20
            //     },
            //     1241: {
            //       slidesPerView: options['grid'],
            //       spaceBetween: 30
            //     }
            //   }

            // });

            //       }
            //     }
      
            //     }
                
   
            //     swiperMode();
               
            //     /* On Resize
            //     **************************************************************/
            //     window.addEventListener('resize', function() {
            //     swiperMode();
            //     });

          });
        });
      }

      _fetchProducts();
    }
  }


  RecentlyViewedProductsSection();

});